import { CustomStyles } from 'components/generics/fields/SelectInput/custom-styles';
import { ComponentProps } from 'react';
import Select from 'react-select';

const SelectInput = ({ ...props }: ComponentProps<Select>) => {
  return (
    <Select
      styles={CustomStyles}
      {...props}
    />
  );
};

export default SelectInput;
